// extracted by mini-css-extract-plugin
export default {"offerModal":"styles_offerModal__itlFO","title":"styles_title__AHp3B","text":"styles_text__FlxEf","price":"styles_price__n57tC"};